export default {
  methods: {
    imgOperate() {
      if (!this.q.imgUrl) {
        return this.defaultImg;
      }
      if (this.q.imgUrl.indexOf("?") > -1) {
        return (
          this.q.imgUrl +
          "&x-oss-process=image/resize,m_fill,h_120,w_750,limit_0"
        );
      }
      return (
        this.q.imgUrl + "?x-oss-process=image/resize,m_fill,h_120,w_750,limit_0"
      );
    },
  },
};
